"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.propsConfig = exports.popoverConfig = exports.intialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'tradVRoth';
var idPrefix = exports.idPrefix = 'tvr_';
var dropdownOptions = exports.dropdownOptions = {
  statesArray: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
  filingArray: ['single', 'married'],
  lastYearTaxRatesArray: ['10%', '12%', '22%', '24%', '32%', '35%', '37%'],
  retTaxRateArray: ['higher', 'lower'],
  taxPreferencesArray: ['now', 'later'],
  planTypeArray: ['traditional', 'roth'],
  employerMatchYNArray: ["doesn't match", "matches"]
};
var popoverConfig = exports.popoverConfig = {};
var propsConfig = exports.propsConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/rothTraditional_v0.23.11',
    Icon: 'icon-transfer-black',
    Label: 'Traditional vs. Roth Contribution Calculator',
    HasBorder: true,
    Steps: [{
      Title: 'Which option is right for me?',
      Description: '',
      SecondaryDescription: 'Use our Traditional vs. Roth Contribution Calculator to help you decide which new account type may better prepare you for retirement.',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: 'Which option is right for me?',
      Description: '',
      SecondaryDescription: 'Use our Traditional vs. Roth Contribution Calculator to help you decide which new account type may better prepare you for retirement.',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Calculate',
        Icon: 'icon-arrow',
        Variant: '',
        Side: ''
      },
      RightHandButton: {
        Label: '',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: '',
        Description: '',
        CTAList: [{
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: ''
        }]
      }
    }, {
      Title: '',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next Steps',
        Description: 'Discuss your results with a financial professional today.',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: 'link'
        }, {
          Label: '',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};
var validationConfigPage1 = yup.object().shape({
  currentAge: yup.number('Your current age must be a number').required('Must be between 0 - 99 years of age').min(0, 'Must be between 0 - 99 years of age').max(99, 'Must be between 0 - 99 years of age'),
  state: yup.string().required('Please select your state').oneOf(dropdownOptions.statesArray),
  retAge: yup
  // Error message: Must be at least (currentAge + 1) and at most 120 years of age
  // Updated input validation as of 3/21/2023: retAge = currentAge + 1
  .number('Your retirement age must be a number').required('Must be between 1 - 120 years of age').test((info, meta) => {
    // Must be greater than or equal to currentAge, must be less than or equal to 120
    var retAgeMaxCheck = info > meta.parent.currentAge;
    var lessThanOrEqualTo120 = info <= 120;

    // If a user hasn't entered a currentAge (currentAge is empty), then don't return an error relating to currentAge
    if (meta.parent.currentAge === '' || !meta.parent.currentAge) return true;
    return retAgeMaxCheck && lessThanOrEqualTo120 ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be greater than your current age of ".concat(meta.parent.currentAge, " and at most 120 years of age")
    });
  }),
  withdrawalAge: yup
  // Must be at least (retAge) and at most 120 years of age, should also be greater than currentAge + 1
  .number('Your withdrawal age must be a number').required('Must be between your retirement age and 120 years of age').test((info, meta) => {
    // for withdrawal age greater than currentAge + 1 and at least equal to retAge
    var withdrawalAgeGreaterThanOrEqualToCurrentAgePlus1 = info >= meta.parent.currentAge + 1;
    var withdrawalAgeGreaterThanOrEqualToRetirementAge = info >= meta.parent.retAge;
    var maxOfRetirmentAgeAndCurrentAge = Math.max(meta.parent.currentAge + 1, meta.parent.retAge);

    // If a user hasn't entered a currentAge (currentAge is empty), then don't display an error that is related to currentAge
    if (meta.parent.currentAge === '' || !meta.parent.currentAge) return true;
    return withdrawalAgeGreaterThanOrEqualToCurrentAgePlus1 && withdrawalAgeGreaterThanOrEqualToRetirementAge ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be at least ".concat(maxOfRetirmentAgeAndCurrentAge, " years of age")
    });
  }).test((info, meta) => {
    // for withdrawal age greater than or equal to retirementAge, and less than or equal to 120
    var withdrawalAgeMaxCheck = info >= meta.parent.retAge;
    var lessThanOrEqualTo120 = info <= 120;
    return withdrawalAgeMaxCheck && lessThanOrEqualTo120 ? true : meta.createError({
      path: "".concat(meta.path),
      message: "Must be at least ".concat(meta.parent.retAge, " and at most 120 years of age")
    });
  }),
  filingStatus: yup.string().required('Please select your filing status').oneOf(dropdownOptions.filingArray),
  salary: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  lastYearTaxRate: yup.string().required('Please select your tax rate from last year').oneOf(dropdownOptions.lastYearTaxRatesArray)
});
var validationConfigPage2Additions = yup.object().shape({
  retTaxRate: yup.string().required('Please select an option').oneOf(dropdownOptions.retTaxRateArray),
  preference: yup.string().required('Please select an option').oneOf(dropdownOptions.taxPreferencesArray),
  currentContribution: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
  planType: yup.string().required('Please select an option').oneOf(dropdownOptions.planTypeArray),
  employerMatchYN: yup.string().required('Please select an option').oneOf(dropdownOptions.employerMatchYNArray),
  employerMatchRate: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when('employerMatchYN', {
    is: 'matches',
    then: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places')
  }),
  employerMatchLimit: yup.number().nullable(true).transform(value => isNaN(value) || value === null || value === undefined ? 0 : value).when('employerMatchYN', {
    is: 'matches',
    then: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places')
  })
});
var validationConfigPage3Additions = yup.object().shape({
  annualRaise: yup.number().required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
  rateOfReturn: yup.number().required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places')
});
var validationConfigPage3 = validationConfigPage1.concat(validationConfigPage2Additions).concat(validationConfigPage3Additions);
var validationConfig = exports.validationConfig = [validationConfigPage1, validationConfigPage2Additions, validationConfigPage3];
var intialValuesConfig = exports.intialValuesConfig = {
  currentAge: '',
  state: '',
  retAge: '67',
  withdrawalAge: '73',
  filingStatus: '',
  salary: '',
  lastYearTaxRate: '',
  retTaxRate: '',
  preference: '',
  currentContribution: '',
  planType: '',
  employerMatchYN: "doesn't match",
  employerMatchRate: '',
  employerMatchLimit: '',
  annualRaise: '2',
  rateOfReturn: '6'
};
var initialTouchedConfig = exports.initialTouchedConfig = {};